import { useQuery } from 'react-query';
import { QueryConfig } from '../lib/react-query';
import axios from 'axios';

export type VVPTestConfig = {
  AudioMode: string;
  ControlMode: string;
  FixationAssist: boolean;
  Layout: string;
  LayoutType: string;
  TestDurationLimitSec: number;
  TestEyes: string;
  TutorialEnabled: boolean;
};


export type GetTestConfigResponse = {
  game_settings?: any[];
  success: string;
  test_config: VVPTestConfig;
  has_vvp_settings: boolean;
};

export const getTestConfig = ({
  clinic_user_id,
}: {
  clinic_user_id: string;
}): Promise<GetTestConfigResponse> => {
  return axios.post('/vue_api/get_test_config', { clinic_user_id: clinic_user_id }).then((resp: any) => {
    console.log("getTestConfig::resp", resp);
    const data: GetTestConfigResponse = resp.data;
    return data;
  });
};

type UseTestConfigOptions = {
  clinic_user_id: string;
  config?: QueryConfig<typeof getTestConfig>;
};

export const useVVPTestConfig = ({ config, clinic_user_id }: UseTestConfigOptions) => {
  return useQuery({
    ...config,
    cacheTime: 0,
    queryKey: ['testConfigs', clinic_user_id],
    queryFn: () => getTestConfig({ clinic_user_id }),
  });
};
